import React, { Component } from 'react';
import { Grid, WithStyles, withStyles, Button } from '@material-ui/core';
import awaitingRequestStyle from '../../styles/AwaitingRequest';
import { COURSE_CHANGE_TAB, REQUEST_STATUS } from '../../types/enums/RequestStatus';
import { MyPATDialog } from '../../../common';
import cx from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Package } from '../../types/interfaces/CourseBasicDetails';
import { CourseTypes } from '../../types/enums/CourseTypes';
import { getImageSource, getRequestId, redirectToCoursePreview, redirectToTestseriesPreview } from '../../helpers/helpers';
import { CHANGE_TYPE, CONTENT_LOCATION, COURSE_CHANGE, CHANGE_LABEL, PACKAGE_CHANGE_TYPE, REQUEST_CHANGES, REQUEST_PLACEHOLDER, BUSINESS_TYPE, REQUEST_REMARK } from '../../Constants/constants';
import { convertCamelCaseToText, convertDateToHHMM, convertDaysToReadableFormat, formatDateToDayMonthYear, formatDateToMonthTime, getCharacterCount, getLabel } from '../../../../utils';
import { contentManagementService } from '../../service';
import { courseManagementActions } from '../../reducers/courseManagementReducer';
import { rejectCourse } from '../../actions/courseManagementActions';
import ACLService from '../../../acl/services/aclService';

interface RequestProps extends WithStyles<typeof awaitingRequestStyle> {
    getPackageByIdData: Package,
    history: any,
    setCourseRequest: Function,
    courseRequest: any,
    rejectionRemarkVisible: boolean,
    setRejectionRemark: Function,
    rejectCourse: Function,
    requestState: string
}

interface RequestState {
    activeTab: number,
    viewChangeVisible: boolean,
    remarkContainerVisible: boolean,
    requestChanges: any,
    status: REQUEST_STATUS,
    loading: boolean,
    remark: string
}

class RequestStaus extends Component<RequestProps, RequestState> {
    constructor(props: any) {
        super(props);
        this.state = {
            activeTab: 0,
            viewChangeVisible: false,
            remarkContainerVisible: false,
            requestChanges: this.getDefaultChange(),
            status: REQUEST_STATUS.AWAITING,
            loading: true,
            remark: ''
        };
    }

    dateChanges = [CHANGE_TYPE.START_DATE, CHANGE_TYPE.END_DATE];
    businessType = [CHANGE_TYPE.AVAILABLE_FOR_CRP, CHANGE_TYPE.AVAILABLE_FOR_NCRP];
    processedRequest = [REQUEST_STATUS.REJECTED, REQUEST_STATUS.CLOSED];

    getDefaultChange() {
        const changesKeys = Object.values(REQUEST_CHANGES);
        const requestChanges: any = {};
        changesKeys.forEach(changeProperty => {
            requestChanges[changeProperty] = [];
        });
        return requestChanges;
    }


    componentDidMount(): void {
        const requestId = getRequestId();
        if (requestId) {
            contentManagementService.getPackageByRequestId(requestId).then((res: any) => {
                if (res.statusCode === 200) {
                    this.props.setCourseRequest(res.responseObject);
                    this.setState({ status: res.responseObject.status });
                }
                this.setState({ loading: false });
            })
        }
    }

    setChangesDetails(changesDetails: any) {
        const newRequestChanges = this.getDefaultChange();
        (changesDetails.reorderedChanges || []).forEach((change: any) => {
            newRequestChanges[REQUEST_CHANGES.REORDER].push(change);
        });
        (changesDetails.dateChanges || []).forEach((change: any) => {
            newRequestChanges[REQUEST_CHANGES.DATE_CHANGE].push(change);
        });
        
        this.setState({ requestChanges: newRequestChanges }, () => {
            COURSE_CHANGE.some((_, requestIndex) => {
                const request = this.getRequestType(requestIndex);
                const requestAvailable = this.getRequestAvailable(request);
                requestAvailable && this.setState({ activeTab: requestIndex });
                return requestAvailable;
            });
        });
    }


    handleTabClick = (tabIndex: number) => {
        if (tabIndex !== this.state.activeTab) {
            this.setState({ activeTab: tabIndex });
        }
    };
    handleViewChanges = (event: any, changesDetails?: any) => {
        this.setState({ viewChangeVisible: !this.state.viewChangeVisible });
        changesDetails && this.setChangesDetails(changesDetails);

    }
    handleRemarkChanges = (event: any) => {
        this.setState({ remarkContainerVisible: !this.state.remarkContainerVisible });
    }
    handleCurrentCourse = (event: any) => {
        const { type, _id } = this.props.getPackageByIdData;
        const { history } = this.props;
        const redirectCoursePreview = type === CourseTypes.testSeries ? redirectToTestseriesPreview : redirectToCoursePreview;
        window.open(redirectCoursePreview(_id), '_blank');
    }
    getOtherInfo(changesList: any[]) {
        const otherChanges: any = {
            [PACKAGE_CHANGE_TYPE.BASIC_INFO]: [],
            [PACKAGE_CHANGE_TYPE.COURSE_INFO]: [],
        };

        changesList.forEach((changes: any) => {
            otherChanges[changes.type].push(changes)
        });

        return otherChanges;
    }

    getLastAddedContent(path: any) {
        let contentName = '';
        if (path.content) {
            contentName = path.content.name;
        } else if (path.concept) {
            contentName = path.concept.conceptName;
        } else if (path.chapter) {
            contentName = path.chapter.chapterName;
        } else if (path.subject) {
            contentName = path.subject.subjectName;
        } else if (path.week) {
            contentName = path.week.weekNo;
        } else if (path.phase) {
            contentName = path.phase.phaseNo;
        }

        return contentName;
    }

    getAddChange() {
        const { requestChanges, activeTab } = this.state;
        const addChanges = requestChanges[REQUEST_CHANGES.ADD];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.ADDED })}>
            <h1 className='mainHeading'><strong>{addChanges.length}</strong> new requests</h1>
            {addChanges.map((change: any) => {
                const path = change.newPath;
                const addedContent = path.content && path.content.name;
                return <div>
                    <div className='phaseBlockSection'>
                        <div className='phaseBlockCol'>
                            <ul className='phaseInfo'>
                                <li className='whiteSpaceNoWrap'>Phase: <strong>{path.phase && path.phase.phaseNo}</strong></li>
                                <li className='whiteSpaceNoWrap'>Week: <strong>{path.week && path.week.weekNo}</strong></li>
                                <li>{path.subject && path.subject.subjectName}</li>
                                <li>{path.chapter && path.chapter.chapterName}</li>
                                <li>{path.concept && path.concept.conceptName}</li>
                            </ul>
                            <div className='phaseList'>
                                <div className='paraSection'>
                                    {addedContent && <span className='iconCol'><img src={getImageSource(change.entityType)} alt='Content Type' /></span>}
                                    <p>{this.getLastAddedContent(path)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            })
            }
        </div>);
    }

    getRemoveChange() {
        const { requestChanges, activeTab } = this.state;
        const oldChanges = requestChanges[REQUEST_CHANGES.REMOVE];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.REMOVED })}>
            <h1 className='mainHeading'><strong>{oldChanges.length}</strong> new requests</h1>
            {
                oldChanges.map((change: any) => {
                    const path = change.oldPath;
                    return <div>
                        <div className='phaseBlockSection'>
                            <div className='phaseBlockCol'>
                                <ul className='phaseInfo'>
                                    <li className='whiteSpaceNoWrap'>Phase: <strong>{path.phase &&path.phase.phaseNo}</strong></li>
                                    <li className='whiteSpaceNoWrap'>Week: <strong>{path.week && path.week.weekNo}</strong></li>
                                    <li>{path.subject && path.subject.subjectName}</li>
                                    <li>{path.chapter && path.chapter.chapterName}</li>
                                    <li>{path.concept && path.concept.conceptName}</li>
                                </ul>
                                <div className='phaseList'>
                                    <div className='paraSection'>
                                        <span className='iconCol'><img src={getImageSource(change.entityType)} alt='Content Type' /></span>
                                        <p>{this.getLastAddedContent(path)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                })
            }
        </div>);

    }

    getDateChanges() {
        const { requestChanges, activeTab } = this.state;
        const dateChanges = requestChanges[REQUEST_CHANGES.DATE_CHANGE];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.DATE_CHANGE })}>
            <h1 className='mainHeading'><strong>{dateChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {!!dateChanges.length && <div className='phaseBlockCol'>
                    <ul className='phaseList'>
                        {
                            dateChanges.map((change: any) =>
                                this.getCoursePlanChange(change)
                            )
                        }
                    </ul>
                </div>}
            </div>
        </div>);
    }
    getReorderChanges() {
        const { requestChanges, activeTab } = this.state;
        const reOrderChanges = requestChanges[REQUEST_CHANGES.REORDER];
        return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_TAB.REORDERED })}>
            <h1 className='mainHeading'><strong>{reOrderChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {reOrderChanges.map((change: any) => {
                    const oldPath = change.oldPath;
                    const newPath = change.newPath;
                    return <>
                        <div className='phaseBlockCol'>
                            <div className='phaseInfoGroup'>
                                <ul className='phaseInfo'>
                                    <li className='whiteSpaceNoWrap'>Phase: <strong>{newPath.phase.phaseNo}</strong></li>
                                    <li className='whiteSpaceNoWrap'>Week: <strong>{newPath.week.weekNo}</strong></li>
                                    <li>{newPath.subject.subjectName}</li>
                                    <li>{newPath.chapter.chapterName}</li>
                                    <li>{newPath.concept && newPath.concept.conceptName}</li>
                                </ul>
                                <ul className='phasePrevInfo'>
                                    <li className='whiteSpaceNoWrap'>Previously in : Phase: {oldPath.phase.phaseNo}</li>
                                    <li className='whiteSpaceNoWrap'>Week: {oldPath.week.weekNo}</li>
                                    <li>{oldPath.subject.subjectName}</li>
                                    <li>{oldPath.chapter.chapterName}</li>
                                    <li>{oldPath.concept && oldPath.concept.conceptName}</li>
                                </ul>
                            </div>
                            <ul className='phaseList'>
                            {(newPath.concept && newPath.concept.conceptName) || newPath.chapter.chapterName}
                            </ul>
                        </div>
                    </>
                })
                }
            </div>
        </div>);
    }
    getCourseName(change: any) {
        return (<li>
            <h2 className='phaseTitle'>Course Name</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/course-ic.svg' alt='Course' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Course Name : {change.currentValue} </p>
        </li>);
    }
    getCourseStartDate(change: any) {
        return (<li>
            <h2 className='phaseTitle'>Course Start Date</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/calendar-green-ic.svg' alt='Calendar' /></span>
                <p>{formatDateToDayMonthYear(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Course Start Date :  {formatDateToDayMonthYear(change.currentValue)}</p>
        </li>);
    }

    getCourseEndDate(change: any) {
        return (<li>
            <h2 className='phaseTitle'>Course End Date</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/calendar-red-ic.svg' alt='Calendar' /></span>
                <p>{formatDateToDayMonthYear(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Course End Date :  {formatDateToDayMonthYear(change.currentValue)}</p>
        </li>);
    }

    getAdminName(adminList: any[]) {
        return (adminList || []).map((adminDetails: any) => adminDetails.fullName).join(',');
    }

    getCourseAdminName(change: any) {
        const proposedChange = this.getAdminName(change.proposedChange);
        const currentValue = this.getAdminName(change.currentValue);

        return (<li>
            <h2 className='phaseTitle'>Admin Name</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/admin-ic.svg' alt='Admin' /></span>
                <p>{(proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Admin Name : {currentValue}</p>
        </li>);
    }

    getCourseDuration(change: any) {
        return (<li>
            <h2 className='phaseTitle'>Course Duration</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/duration-ic.svg' alt='Duration' /></span>
                <p>{convertDaysToReadableFormat(change.proposedChange)} Course</p>
            </div>
            <p className='otherInfo'>Previously Course Duration : {convertDaysToReadableFormat(change.currentValue)} Course</p>
        </li>);
    }

    getBasicChange(change: any) {
        let basicChange = <></>;
        switch (change.changeType) {
            case CHANGE_TYPE.START_DATE:
                basicChange = this.getCourseStartDate(change);
                break;
            case CHANGE_TYPE.END_DATE:
                basicChange = this.getCourseEndDate(change);
                break;
            case CHANGE_TYPE.NAME_CHANGE:
                basicChange = this.getCourseName(change);
                break;
            case CHANGE_TYPE.DURATION_CHANGE:
                basicChange = this.getCourseDuration(change);
                break;
            case CHANGE_TYPE.ADMIN_NAME:
                basicChange = this.getCourseAdminName(change);
                break;
            default:
                basicChange = <></>;
        }

        return basicChange;
    }

    getArrowPathName(property: string, value: string, arrowNotVisible?: boolean) {
        if (!value) {
            return <></>;
        }
        return (<>
            {!arrowNotVisible &&
                <img className='arrowIcon' src='/assets/svg/course-plan-request/arrow-ic.svg' alt='Left Arrow' />}
             {' '} {property} {value} 
        </>);
    }


    getCoursePlanChange(change: any) {
        const path = change.entityPath;
        if (!this.dateChanges.includes(change.changeType)) {
            return;
        }
        const isStartDateChanges = change.changeType === CHANGE_TYPE.START_DATE;
        const imageUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.ICON : CHANGE_LABEL.END_DATE.ICON;
        const clockUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.CLOCK_ICON : CHANGE_LABEL.END_DATE.CLOCK_ICON
        return (<li>
            <div className='datePhaseTitle'>
                {path && <>
                    {path.content && <>
                        <span className='iconCol'>
                            <img src='/assets/svg/course-plan-request/test.svg' alt='Test' />
                        </span>
                        <p>{path.content.name || ''}  -</p>&nbsp;
                    </>
                    }
                    {this.getArrowPathName(CONTENT_LOCATION.PHASE, path.phase && path.phase.phaseNo, true)}
                    {this.getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo)}
                    {this.getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName)}
                    {this.getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName)}
                    {this.getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName)}
                </>}&nbsp;
            </div>
            <div className='datePhaseLabel'>
                {getLabel(isStartDateChanges, !!(path.content))}
            </div>
            <div className='paraSection'>
                <span className='iconCol'>
                    <img src={imageUrl} alt='Calendar' />
                </span>
                <p>{formatDateToDayMonthYear(change.proposedChange)} </p>
                {path.content && <span className='iconCol'>
                    <img src={clockUrl} alt='Calendar' />
                </span>}
                <p>{path.content && convertDateToHHMM(change.proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously
                {(path && !path.content) && <>
                {this.getArrowPathName(CONTENT_LOCATION.PHASE, path.phase.phaseNo, true)}
                {this.getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo, true)}
                {this.getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName, true)}
                {this.getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName, true)}
                {this.getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName, true)}
                </>}
                {(path && path.content) && <>
                    &nbsp;{isStartDateChanges ? CHANGE_LABEL.START_DATE.TEST_LABEL : CHANGE_LABEL.END_DATE.TEST_LABEL}
                </>}
                &nbsp;: {formatDateToDayMonthYear(change.currentValue)} {path.content && convertDateToHHMM(change.currentValue)}
            </p>
        </li>);
    }
    getOtherChanges() {
        const { requestChanges } = this.state;
        const otherChanges = requestChanges[REQUEST_CHANGES.OTHER];
        const basicInfo = otherChanges.filter((change: any) => change.type === PACKAGE_CHANGE_TYPE.BASIC_INFO);
        const coursePlan = otherChanges.filter((change: any) => change.type === PACKAGE_CHANGE_TYPE.COURSE_INFO);

        return (<div className={cx('coursePlanRequestContent', { 'active': this.state.activeTab === COURSE_CHANGE_TAB.OTHER_CHANGES })}>
            <h1 className='mainHeading'><strong>{otherChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {!!basicInfo.length && <div className='phaseBlockCol'>
                    <ul className='phaseInfo'>
                        <li>Basic info</li>
                    </ul>
                    <ul className='phaseList'>
                        {basicInfo.map((change: any) =>
                            this.getBasicChange(change)
                        )}
                    </ul>
                </div>}
                {!!coursePlan.length && <div className='phaseBlockCol'>
                    <ul className='phaseInfo'>
                        <li>Course plan</li>
                    </ul>
                    <ul className='phaseList'>
                        {
                            coursePlan.map((change: any) =>
                                this.getCoursePlanChange(change)
                            )
                        }
                    </ul>
                </div>}
            </div>
        </div>);
    }

    getEnabledDisabledLabel(enabled: boolean) {
        return enabled ? CHANGE_LABEL.ENABLED.LABEL : CHANGE_LABEL.DISABLED.LABEL;
    }

    getPublishDetails(change: any) {
        if (!change || CHANGE_TYPE.GLORIFIRE_PUBLISH !== change.changeType) {
            return;
        }
        const enabled = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = enabled ? CHANGE_LABEL.ENABLED.ICON : CHANGE_LABEL.DISABLED.ICON;

        return (
            <li>
                <h2 className='phaseTitle'>Publish on glorifire.com</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Glorifire Publish' /></span>
                    <p>{this.getEnabledDisabledLabel(enabled)}</p>
                </div>
                <p className='otherInfo'>Previously Publish on glorifire.com : {this.getEnabledDisabledLabel(currentValue)} </p>
            </li>);
    }

    getTestUserDetails(change: any) {
        if (!change || CHANGE_TYPE.TEST_USER_PUBLISH !== change.changeType) {
            return;
        }
        const enabled = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = enabled ? CHANGE_LABEL.ENABLED.ICON : CHANGE_LABEL.DISABLED.ICON;
        return (
            <li>
                <h2 className='phaseTitle'>Publish for test users only</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Disabled' /></span>
                    <p>{this.getEnabledDisabledLabel(enabled)}</p>
                </div>
                <p className='otherInfo'>Previously Publish for test users only : {this.getEnabledDisabledLabel(currentValue)}</p>
            </li>
        );
    }
    getPaidFreeText(paidCourse: any) {
        return paidCourse ? CHANGE_LABEL.PAID.LABEL : CHANGE_LABEL.FREE.LABEL;
    }

    getPriceDetails(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.COURSE_TYPE) {
            return;
        }
        const paidCourse = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = paidCourse ? CHANGE_LABEL.PAID.ICON : CHANGE_LABEL.FREE.ICON;

        return (<>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='Price' /></span>
                <p>{this.getPaidFreeText(change)}</p>
            </div>
            <p className='otherInfo'>Previously Course Type : {this.getPaidFreeText(currentValue)}</p>
        </>);
    }
    getYesNoText(flag: boolean) {
        return flag ? CHANGE_LABEL.YES : CHANGE_LABEL.NO;
    }

    getSoldLocation(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.COURSE_TYPE) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = proposedChange ? CHANGE_LABEL.YES.ICON : CHANGE_LABEL.NO.ICON;

        return (<>
            <h2 className='phaseSubTitle'>Course Sells Outside India</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='Outside Course' /></span>
                <p>{this.getYesNoText(proposedChange)}</p>
            </div>
            <p className='otherInfo'>Previously Course Sells Outside India : {this.getYesNoText(currentValue)}</p>
        </>);
    }

    getAvailableBusinessType(change: any, businessType: string) {
        if (!change || !this.businessType.includes(change.changeType)) {
            return;
        }
        return (<li>
            <h2 className='phaseSubTitle'>Available For {businessType} :
                <span> {this.getYesNoText(change.proposedChange).LABEL}
                </span>
            </h2>
            <p className='otherInfo'>Previously Available For {businessType} : {this.getYesNoText(change.currentValue).LABEL}</p>
        </li>);
    }

    getPriceChange(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.COURSE_PRICE) {
            return;
        }

        return (<>
            <h2 className='phaseSubTitle'>Course Price</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/currency-ic.svg' alt='Currency' /></span>
                <p> INR {change.proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Course Price : INR - {change.currentValue}</p>
        </>);
    }

    getDiscountChange(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.DISCOUNT) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = (proposedChange - currentValue) >= 0 ? CHANGE_LABEL.PERCENTAGE_INCREASE.ICON : CHANGE_LABEL.PERCENTAGE_INCREASE.ICON;

        return (<>
            <h2 className='phaseSubTitle'>Discount (%)</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='discount' /></span>
                <p>{proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Discount : {currentValue}</p>
        </>
        );
    }

    getMainTestInfoIconChange(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.MAIN_TEST_INFO_ICON) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = CHANGE_LABEL.MAIN_INFO.ICON;

        return (<li>
            <h2 className='phaseTitle'>Main Test Info Icon Text</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src={imageUrl} alt='Main Test' /></span>
                <p>{proposedChange}</p>
            </div>
            <p className='otherInfo'>Previously Main Test Info Icon Text : {currentValue}</p>
        </li>);
    }

    getConceptTestInfo(change: any) {

        if (!change || change.changeType !== CHANGE_TYPE.CONCEPT_TEST_INFO_ICON) {
            return;
        }
        const proposedChange = change.proposedChange;
        const currentValue = change.currentValue;
        const imageUrl = CHANGE_LABEL.CONCEPT_INFO.ICON;

        return (<>
            <li>
                <h2 className='phaseTitle'>Concept Test Info Icon (Package Name)</h2>
                <div className='paraSection'>
                    <span className='iconCol'><img src={imageUrl} alt='Concept Test' /></span>
                    <p>{proposedChange}</p>
                </div>
                <p className='otherInfo'>Previously Concept Test Info Icon (Package Name) :{currentValue}</p>
            </li>
        </>);
    }

    getGeneralSetting(generalSetting: any[]) {
        if (!generalSetting.length) {
            return;
        }
        const publishChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.GLORIFIRE_PUBLISH);
        const testChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.TEST_USER_PUBLISH);
        const paidChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.COURSE_TYPE);
        const priceChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.COURSE_PRICE);
        const discountChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.DISCOUNT);
        const mainTestIconChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.MAIN_TEST_INFO_ICON);
        const conceptTestIconChange = generalSetting.find(change => change.changeType === CHANGE_TYPE.CONCEPT_TEST_INFO_ICON);
        const availableForCRP = generalSetting.find(change => change.changeType === CHANGE_TYPE.AVAILABLE_FOR_CRP);
        const availableForNCRP = generalSetting.find(change => change.changeType === CHANGE_TYPE.AVAILABLE_FOR_NCRP);
        const courseTypeVisible = paidChange || discountChange || priceChange;

        return (<div className='phaseBlockCol'>
            <ul className='phaseInfo'>
                <li>General Setting</li>
            </ul>
            <ul className='phaseList'>
                {this.getPublishDetails(publishChange)}
                {this.getTestUserDetails(testChange)}
                {courseTypeVisible && <li>
                    <h2 className='phaseTitle'>Course Type</h2>
                    {this.getPriceDetails(paidChange)}
                    {this.getPriceChange(priceChange)}
                    {this.getDiscountChange(discountChange)}
                </li>}
                {this.getMainTestInfoIconChange(mainTestIconChange)}
                {this.getConceptTestInfo(conceptTestIconChange)}
                {this.getAvailableBusinessType(availableForCRP,REQUEST_PLACEHOLDER.CRP.LABEL)}
                {this.getAvailableBusinessType(availableForNCRP,REQUEST_PLACEHOLDER.CRP.LABEL)}
            </ul>
        </div>
        );
    }

    getFaqChange(faqChanges: any[]) {
        if(!faqChanges.length){
            return;
        }

        return (
            <div className='phaseBlockCol'>
                <ul className='phaseInfo'>
                    <li>FAQs</li>
                </ul>
                {faqChanges.map((change: any, index: number) =>
                <ul className='phaseList'>
                    <li>
                            <h2 className='phaseTitle'>Question {index + 1}</h2>
                        <div className='paraSection'>
                            <span className='iconCol'><img src='/assets/svg/course-plan-request/question-ic.svg' alt='Question' /></span>
                            <p>{change.proposedChange.question}</p>
                        </div>
                            <p className='otherInfo'>Previously Question {index + 1} : {change.currentValue.question}</p>

                        <h2 className='phaseSubTitle'>Answer</h2>
                        <div className='paraSection'>
                            <span className='iconCol'><img src='/assets/svg/course-plan-request/syllabus-ic.svg' alt='Syllabus Icon' /></span>
                                <p>{change.proposedChange.answer}</p>
                        </div>
                            <p className='otherInfo'>Previously Answer : {change.currentValue.answer}</p>
                    </li>
                </ul>
                )}
            </div>);
    }

    getMetaTitleChanges(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.META_TITLE) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Title</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-ic.svg' alt='Checklist' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }

    getMetaKeywordChange(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.META_KEYWORD) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Keywords</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-keyword-ic.svg' alt='Checklist Keyword' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }
    getMetaDescriptionChanges(change: any) {
        if (!change || change.changeType !== CHANGE_TYPE.META_DESCRIPTION) {
            return;
        }
        return (<li>
            <h2 className='phaseTitle'>Meta Description</h2>
            <div className='paraSection'>
                <span className='iconCol'><img src='/assets/svg/course-plan-request/checklist-description-ic.svg' alt='Checklist Description' /></span>
                <p>{change.proposedChange}</p>
            </div>
            <p className='otherInfo'>{change.currentValue}</p>
        </li>);
    }

    getSeoChanges(seoChanges: any[]) {
        if (!seoChanges.length) {
            return;
        }
        const metaTitleChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_TITLE);
        const metaKeywordChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_KEYWORD);
        const metaDescriptionChanges = seoChanges.find(change => change.changeType === CHANGE_TYPE.META_DESCRIPTION);

        return (<div className='phaseBlockCol'>
            <ul className='phaseInfo'>
                <li>Course SEO *</li>
            </ul>
            <ul className='phaseList'>
                {this.getMetaTitleChanges(metaTitleChanges)}
                {this.getMetaKeywordChange(metaKeywordChanges)}
                {this.getMetaDescriptionChanges(metaDescriptionChanges)}
            </ul>
        </div>);
    }

    getAdvanceChanges() {
        const advanceChange = this.state.requestChanges[REQUEST_CHANGES.ADVANCE];
        const changeType: any = {
            [PACKAGE_CHANGE_TYPE.SEO]: [],
            [PACKAGE_CHANGE_TYPE.FAQ]: [],
            [PACKAGE_CHANGE_TYPE.GENERAL_SETTING]: [],
        };

        advanceChange.forEach((change: any) => {
            changeType[change.type].push(change);
        });

        return (<div className={cx('coursePlanRequestContent', { 'active': this.state.activeTab === COURSE_CHANGE_TAB.ADVANCE_SETTINGS })}>
            <h1 className='mainHeading'><strong>{advanceChange.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {this.getGeneralSetting(changeType.generalSetting)}
                {this.getFaqChange(changeType.faq)}
                {this.getSeoChanges(changeType.seo)}
            </div>
        </div>);
    }

    getTotalCountChanges() {
        const courseRequest = this.props.courseRequest;
        const { dateChanges = [], reorderedChanges = [] } = courseRequest;
        return (dateChanges || []).length + (reorderedChanges || []).length;
    }

    checkForRequestRejection(status: REQUEST_STATUS) {
        return this.processedRequest.includes(status);
    }

    handleRejectionRemark = () => {
        const { courseRequest } = this.props;
        const { remark } = this.state;
        this.props.setRejectionRemark();
        this.props.rejectCourse({ requestId: courseRequest._id, remark });
    }

    handleCancelRemark = () => {
        this.props.setRejectionRemark();
    }

    setRemark = (event: any) => {
        this.setState({ remark: event.currentTarget.value });
    }
    getRejectionPlaceholder(courseRequest: string) {
        return courseRequest === REQUEST_STATUS.CLOSED ? REQUEST_PLACEHOLDER.CLOSED.PLACEHOLDER : REQUEST_PLACEHOLDER.REJECTED.PLACEHOLDER;
    }
    getRejectionText() {
        const { status } = this.state;
        return status === REQUEST_STATUS.CLOSED ? REQUEST_PLACEHOLDER.CLOSED.LABEL : REQUEST_PLACEHOLDER.REJECTED.LABEL;
    }

    getRequestType(request: number) {
        let currentRequest;
        switch (request) {
            case COURSE_CHANGE_TAB.ADDED:
                currentRequest = REQUEST_CHANGES.ADD;
                break;
            case COURSE_CHANGE_TAB.REORDERED:
                currentRequest = REQUEST_CHANGES.REORDER;
                break;
            case COURSE_CHANGE_TAB.REMOVED:
                currentRequest = REQUEST_CHANGES.REMOVE;
                break;
            case COURSE_CHANGE_TAB.OTHER_CHANGES:
                currentRequest = REQUEST_CHANGES.OTHER;
                break;
            case COURSE_CHANGE_TAB.ADVANCE_SETTINGS:
                currentRequest = REQUEST_CHANGES.ADVANCE;
                break;
            case COURSE_CHANGE_TAB.DATE_CHANGE:
                currentRequest = REQUEST_CHANGES.DATE_CHANGE;
                break;
            default: currentRequest = '';
        }
        return currentRequest;
    }

    getRequestAvailable(requestType: string) {
        return !!((this.state.requestChanges[requestType] || []).length);
    }

    getRejectionHeading() {
        const { status } = this.state;
        return status === REQUEST_STATUS.CLOSED ? REQUEST_REMARK.CLOSED : REQUEST_REMARK.REJECTED;
    }


    render() {
        const { classes, courseRequest = {} } = this.props;
        const { viewChangeVisible, activeTab, remarkContainerVisible, loading, status } = this.state;
        return (!loading && <>
            <div className={cx(classes.coursePlanInfoBox, classes[status])} >
                <div className='listingRow'>
                    <ul className='listing'>
                        <li>Requested on: <strong>{formatDateToMonthTime(courseRequest && courseRequest.createdAt)}</strong></li>
                        <li>Current Course Plan Status: <strong>{convertCamelCaseToText(status)}</strong></li>
                    </ul>
                    <button className='buttonText' onClick={this.handleCurrentCourse}>View Current Course</button>
                </div>
                <div className='awaitingApprovalRow'>
                    <p>request {convertCamelCaseToText(status)}: <strong>{this.getTotalCountChanges()} new change{this.getTotalCountChanges() !== 1 ? 's' : ''}</strong></p>
                    <div>
                        <button className='buttonText' onClick={(event) => this.handleViewChanges(event, courseRequest)} >View Change Request</button>
                        {this.checkForRequestRejection(status) && <button className='buttonText' onClick={this.handleRemarkChanges}>View {this.getRejectionText()} Remark</button>}
                    </div>
                </div>
            </div>
            <MyPATDialog
                classes={{ root: classes.coursePlanRequestModal }}
                dialogOpen={viewChangeVisible}
                onDialogClose={false}
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                }}
                customDialogActions={
                    <>
                        <Grid container justify='center'>
                            <Grid item>
                                <Button color='primary' variant='contained' className='btnBlue' onClick={this.handleViewChanges}>Okay</Button>
                            </Grid>
                        </Grid>
                    </>
                }
            >
                <h6 className='title'>
                    Course Plan Request Summary
                    <img className='closeIcon' src='/assets/svg/course-plan-request/close-modal-ic.svg' alt='Close' onClick={this.handleViewChanges} />
                </h6>

                <div className='confirmationMessageBox'>
                    <div className='confirmationMessage'>
                        <img src="/assets/svg/course-plan-request/clock-history-ic.svg" alt="Clock History" />
                        <p>You are trying to make following change(s) to this course that needs approval Are You sure you want to proceed and submit the request?</p>
                    </div>
                    <p className='noteText'><strong>Note:</strong> All the other changes (if any) will be published directly</p>
                </div>

                <ul className='coursePlanRequestTab'>
                    {COURSE_CHANGE.map((courseChange, tabIndex) =>
                        this.getRequestAvailable(this.getRequestType(tabIndex)) && <li className={cx({ 'active': this.state.activeTab === tabIndex })} onClick={() => this.handleTabClick(tabIndex)} key={tabIndex}><span>{courseChange}</span></li>
                    )}
                </ul>
                {this.getAddChange()}
                {this.getRemoveChange()}
                {this.getReorderChanges()}
                {this.getOtherChanges()}
                {this.getAdvanceChanges()}
                {this.getDateChanges()}
            </MyPATDialog>
            <MyPATDialog
                classes={{ root: classes.rejectionRemarkModal }}
                dialogOpen={remarkContainerVisible}
                onDialogClose={false}
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                }}
                customDialogActions={
                    <Button color='primary' variant='contained' className='btnBlue' onClick={this.handleRemarkChanges}>Ok, Got it!</Button>
                }
            >
                <h6 className='title'>{this.getRejectionHeading()} Remark<img className='closeIcon' src='/assets/svg/course-plan-request/close-modal-ic.svg' onClick={this.handleRemarkChanges} alt='Close' /></h6>
                <div className='ContentArea'>
                    <p>{courseRequest && (courseRequest.rejectionRemark || courseRequest.closeRemark)}</p>
                </div>
            </MyPATDialog>
            <MyPATDialog
                classes={{ root: classes.rejectRequestModal }}
                dialogOpen={this.props.rejectionRemarkVisible}
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                }}
                customDialogActions={
                    <>
                        <Button color='primary' variant='contained' className='btnBlue' onClick={this.handleRejectionRemark}>Submit</Button>
                    </>
                }
            >
                <h6 className='title'>
                    Add Remark
                    <img className='closeIcon' src='/assets/svg/course-plan-request/close-modal-ic.svg' alt='Close' onClick={this.handleCancelRemark} />
                </h6>

                <div className='textareaContent'>
                    <textarea name='remark' placeholder={`Please enter the reason to ${this.getRejectionPlaceholder(this.props.requestState)} the Request .`}
                        value={this.state.remark}
                        onChange={this.setRemark}>
                    </textarea>
                </div>
            </MyPATDialog>
        </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        getPackageByIdData: state.courseMangementData.contentManagementData.packageByIdData.packageData,
        courseRequest: state.courseMangementData.courseManagementReducer.courseRequest,
        rejectionRemarkVisible: state.courseMangementData.courseManagementReducer.rejectionRemarkVisible,
        requestState: state.courseMangementData.courseManagementReducer.requestState
    }
}

const mapDispatchToProps = {
    setCourseRequest: courseManagementActions.setCourseRequest,
    setRejectionRemark: courseManagementActions.setRejectionRemark,
    rejectCourse,
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(awaitingRequestStyle)(withRouter(RequestStaus)));